import styled from "styled-components";

const CreatePlaylist = styled.div`
  ${(props) =>
    props.showBorder &&
    `
    border-top: 1px solid ${({ theme }) => theme.colors.grey};
  `};
  width: 100%;

  &:hover {
    background: ${({ theme }) => theme.colors.grey};
  }
`;

export { CreatePlaylist };
